import { useQuery } from '@tanstack/react-query';
import { myInsightsQueryKeys } from './queryKeys';
import { SessionByDateDto } from '@repo/shared/dtos/my-insights/SessionByDateDto';
import { SESSIONS_BY_DATE_ENDPOINT } from '../config/constants';

export function useSessionsByDate(selectedDate: Date | null) {
  const dateISO = selectedDate?.toISOString().split('T')[0] ?? '';

  return useQuery({
    queryKey: myInsightsQueryKeys.sessions.byDate(dateISO),
    queryFn: async (): Promise<SessionByDateDto[]> => {
      const res = await fetch(`${SESSIONS_BY_DATE_ENDPOINT}?date=${dateISO}`);
      if (!res.ok) throw new Error('Failed to fetch sessions by date');
      return res.json();
    },
    enabled: !!selectedDate,
    retry: 2,
  });
}
